import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43eba4a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "data-table" }
const _hoisted_3 = { class: "data-table__head" }
const _hoisted_4 = { class: "data-table__body" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fallback" }, "Não há nada por aqui.", -1))
const _hoisted_6 = { class: "pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "data-table-wrapper",
      id: _ctx.id
    }, [
      _createElementVNode("table", _hoisted_2, [
        _createElementVNode("thead", _hoisted_3, [
          _renderSlot(_ctx.$slots, "thead", {}, undefined, true)
        ]),
        _createElementVNode("tbody", _hoisted_4, [
          _renderSlot(_ctx.$slots, "tbody", {}, () => [
            _hoisted_5
          ], true)
        ])
      ])
    ], 8, _hoisted_1),
    _createElementVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "pagination", {}, undefined, true)
    ])
  ], 64))
}